module.exports = __webpack_public_path__ + "media/images/landing/useek_logo_dark-a18996a6f9de2fb3456b752f35c1d88a.png";